module.exports = __webpack_public_path__ + "img/puppy-what-we-do.c6314498.webp";